import axios from 'axios';

// Function to handle logout (will be set by the app)
let logoutHandler = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

// Create axios instance with base configuration
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token is expired or invalid
      localStorage.removeItem('token');
      
      // Use logout handler if available, otherwise fallback to window.location
      if (logoutHandler) {
        logoutHandler();
      } else {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

// Helper function for fetch-style API calls with automatic 401 handling
export const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };

  try {
    const response = await fetch(url, config);
    
    // Handle 401 responses
    if (response.status === 401) {
      localStorage.removeItem('token');
      
      // Use logout handler if available, otherwise fallback to window.location
      if (logoutHandler) {
        logoutHandler();
      } else {
        window.location.href = '/login';
      }
      throw new Error('Session expired. Please login again.');
    }
    
    return response;
  } catch (error) {
    throw error;
  }
};

export default api;
